import { Component, OnInit } from '@angular/core';
import { AngazovanjeRo } from './angazovanje-ro';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-angazovanje-ro',
  templateUrl: './angazovanje-ro.component.html'
})
export class AngazovanjeRoComponent 
extends BaseModalContainer<AngazovanjeRo> 
implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<AngazovanjeRo>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService

  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
   }

  ngOnInit() {
  }

}
